import CryptoJS from 'crypto-js';

const SECRET_KEY = 'collaboration-app-secret-key';
const SESSION_COOKIE_NAME = 'user_session';

export const hashPassword = (password) => {
  return CryptoJS.SHA256(password + SECRET_KEY).toString();
};

export const generateTeamCode = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const generateUniqueCode = () => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Cookie helpers
const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (JSON.stringify(value) || "") + expires + "; path=/; SameSite=Strict";
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(c.substring(nameEQ.length, c.length));
      } catch (e) {
        return null;
      }
    }
  }
  return null;
};

const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

// Updated to use Cookie with ID and unique_code
export const setCurrentUser = (user) => {
  if (!user || !user.id || !user.unique_code) return;
  // Store ID and unique_code in the cookie. No other sensitive data.
  setCookie(SESSION_COOKIE_NAME, { id: user.id, unique_code: user.unique_code }, 7); 
};

export const getCurrentUser = () => {
  // Returns session info (e.g. { id: ..., unique_code: ... })
  return getCookie(SESSION_COOKIE_NAME);
};

export const removeCurrentUser = () => {
  eraseCookie(SESSION_COOKIE_NAME);
  localStorage.removeItem('currentUser');
};

export const logout = () => {
  removeAuthToken();
  removeCurrentUser();
  window.location.href = '/';
};